<div class="relative flex h-full flex-col gap-8 py-5">
  <div class="flex justify-between items-center gap-4 px-5">
    <div class="flex items-center gap-2">
      <pl-icon
        [frame]="IconFrame.round"
        [name]="PlIcon.arrow_left"
        (click)="closeModal()"
        class="h-6 w-6 cursor-pointer border-transparent bg-transparent text-pl-orange-500 hover:bg-pl-orange-300"
      />
      <h3>{{ 'profile.weekly_lifeacts.my_lifeacts' | translate }}</h3>
    </div>

    <pl-my-life-acts-download-button
      *ngIf="!stepDataRetrieveInProgress()"
      [lifeactStepData]="currentlySelectedLifeactStepData()"
    />
  </div>

  <div class="flex grow flex-col overflow-auto px-5">
    <div *ngIf="stepDataRetrieveInProgress()" class="grow flex justify-center items-center">
      <pl-loader />
    </div>
    <pl-my-life-acts-blocks
      *ngIf="!stepDataRetrieveInProgress()"
      class="block grow min-w-0"
      [lifeactStepData]="currentlySelectedLifeactStepData()"
    />
  </div>
</div>
